import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=c3227626&scoped=true"
import script from "./Files.vue?vue&type=script&lang=ts"
export * from "./Files.vue?vue&type=script&lang=ts"
import style0 from "./Files.vue?vue&type=style&index=0&id=c3227626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3227626",
  null
  
)

export default component.exports